/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import { Heading1, Paragraph } from '@motili/ui';

import StyledLabelWithRequired from '../../../components/styled/StyledLabelWithRequired';

import { useAppSelector } from '../../../common/redux/hooks';
import TradeOptions from './TradeOptions';
import ServiceProviderCheckboxOptions from './ServiceProviderCheckboxOptions';

const TradesAndServices = () => {
    const teamInfo = useAppSelector(
        ({ contractorRegistration }) =>
            contractorRegistration.contractor.teamInfo
    );
    const trades = useAppSelector(
        ({ contractorRegistration }) => contractorRegistration.contractor.trades
    );

    return (
        <>
            <Heading1>Trades & Services</Heading1>
            <Paragraph>
                In order to place you with the proper jobs, we’d like to know
                which types of trades you service. Don’t worry, this can be
                changed as you develop new skills or prioritize some over
                others.
            </Paragraph>
            <StyledLabelWithRequired required>
                What type(s) of trades do you service? Select all that apply.
            </StyledLabelWithRequired>
            <TradeOptions trades={trades} />
            <br />
            <StyledLabelWithRequired required>
                What type(s) of customers do you provide service to?
            </StyledLabelWithRequired>
            <ServiceProviderCheckboxOptions teamInfo={teamInfo} />
        </>
    );
};

export default TradesAndServices;
